import { Injectable } from "@angular/core";
import { Action, State, StateContext } from "@ngxs/store";

import { AddSelectedSubtreeVariables, RemoveSelectedSubtreeVariables, ResetSelectedSubtreeVariables } from "./selected-subtree-variables.actions";

export interface SelectedSubtreeVariablesStateModel {
  tags: string[],
}

@State<SelectedSubtreeVariablesStateModel>({
  name: 'selectedSubtreeVariables',
  defaults: {
    tags: [],
  }
})
@Injectable()
export class SelectedSubtreeVariablesState {

  @Action(AddSelectedSubtreeVariables)
  addSelectedVariables(
    ctx: StateContext<SelectedSubtreeVariablesStateModel>,
    { payload: variablesToAdd }: AddSelectedSubtreeVariables
  ) {
    const state = ctx.getState();
    const newTags = new Set([...state.tags, ...variablesToAdd]);
    ctx.patchState({ tags: Array.from(newTags) });
  }

  @Action(RemoveSelectedSubtreeVariables)
  removeSelectedVariables(
    ctx: StateContext<SelectedSubtreeVariablesStateModel>,
    { payload: tagsToRemove }: RemoveSelectedSubtreeVariables
  ) {
    const state = ctx.getState();
    const newTags = state.tags.filter(tag => !tagsToRemove.includes(tag));
    ctx.patchState({ tags: newTags });
  }

  @Action(ResetSelectedSubtreeVariables)
  resetSelectedSubtreeVariables(
    { patchState }: StateContext<SelectedSubtreeVariablesStateModel>
  ) {
    patchState({ tags: [] });
  }
}